import { Box, Flex, Icon, Button, Text } from "@chakra-ui/react";
import FadeTransition from "@components/animation/FadeTransition";
import HeadingWithSubtitle from "@components/common/HeadingWithSubtitle";
import Label from "@components/Label";
import PageLayout from "@components/PageLayout";
import { Check, Kanban, ArrowRight } from "@phosphor-icons/react";
import ReactPlayer from "react-player";
import { NextSeo } from "next-seo";
import Link from "next/link";

const Retrospective = () => {
  const features = [
    "Instant, low latency",
    "Add or remove cards",
    "Three spaces",
    "Save progress and share",
  ];
  return (
    <PageLayout>
      <NextSeo
        title="Realtime Retrospective for Team Daily"
        description="The best way to run a retrospective with your team. Add cards, vote, and discuss what really matters."
      />

      <FadeTransition>
        <Box textAlign="center" my={12}>
          <Icon as={Kanban} width="80px" height="80px" />
          <HeadingWithSubtitle
            title="Retrospective"
            subtitle="Ask your team what really matters and how work could be smoother."
          />

          <Link href="/">
            <Button mt={4} rightIcon={<ArrowRight weight="bold" />}>
              Get started with RetroPlan.io
            </Button>
          </Link>
        </Box>
      </FadeTransition>

      <Flex
        mb={12}
        flexDirection={{ base: "column", lg: "row" }}
        justifyContent="center"
      >
        {features.map((feature) => (
          <Flex
            mb={{ base: 2, lg: 0 }}
            mr={4}
            alignItems="center"
            justifyContent="center"
          >
            <Icon
              mr={2}
              as={Check}
              width="18px"
              height="18px"
              color="green.500"
            />

            <Text>{feature}</Text>
          </Flex>
        ))}
      </Flex>

      <Label textAlign="center" mb={4}>
        Product Video
      </Label>

      <Box
        mx="auto"
        h={{ base: "auto", lg: "500px" }}
        width="fit-content"
        borderWidth="5px"
        borderRadius="lg"
        mb={24}
      >
        <ReactPlayer
          width="100%"
          height="100%"
          loop
          muted
          playing={true}
          url="../video/retrospective.m4v"
        />
      </Box>
    </PageLayout>
  );
};

export default Retrospective;
